import { AbstractPlayer } from './abstract-player'

export class VideoPlayerStore {
    public isScriptLoaded = false
    private players: AbstractPlayer[] = []

    private static _instance: VideoPlayerStore
    public static getInstance(): VideoPlayerStore {
        return this._instance || (this._instance = new this())
    }

    public get featurePlayer(): AbstractPlayer | undefined {
        const featurePlayer = this.players.filter((player) => player.isFeatured)
        return featurePlayer.shift()
    }

    public add(player: AbstractPlayer): void {
        this.players.push(player)
    }

    public pauseAllOther(component: AbstractPlayer): void {
        this.players.forEach((player: AbstractPlayer) => {
            if (player !== component && player.type !== 'hero') {
                player.pause()
            }
        })
    }

    public isFeatured(component: AbstractPlayer): boolean {
        return this.featurePlayer === component
    }

    public setScriptLoaded(): void {
        this.isScriptLoaded = true
    }
}
